export default function gazelleConfig($mdThemingProvider, $mdAriaProvider) {
  //noinspection BadExpressionStatementJS
  'ngInject';


  // if (__DEV__) { console.log('Gazelle Config: Starting...'); }

  // Do Gazelle config work here....

  /* Consider defining full palettes instead of extending material ones
  $mdThemingProvider.definePalette('sms-grey', {
    '50': 'eceff1',    // C1
    '100': 'd2dadf',   // C2
    '200': 'c8d2d7',   // C3
    '300': 'bdcacf',   // C4 prime hue1 background hue1
    '400': 'adbcc3',   // C6
    '500': '8a9fa9',   // C10  primary default $hp-blue-appnav for app-nav
    '600': '9cadb6',   // C8
    '700': '93a7b0',   // C9
    '800': '8a9fa9',   // C10 prime hue2 background hue2
    '900': '253137',   // C0 background hue3
    'A100': '778f9b',  // C16 prime hue3 (accent hue1) default background color - change this to white
    'A200': '5c717b',  // C15 accent default color
    'A400': '445963',  // C18 accent hue2
    'A700': '324349',  // C14 accent hue3
    'contrastDefaultColor': 'light',    // whether, by default, text (contrast)
                                        // on this palette should be dark or light
    'contrastDarkColors': ['50', '100', //hues which contrast should be 'dark' by default
     '200', '300', '400', 'A100'],
    'contrastLightColors': undefined    // could also specify this if default was 'dark'
  });
  */

  $mdThemingProvider.definePalette('printos-blue',
    $mdThemingProvider.extendPalette('blue', {
      '500': '#0096d6', // HP Blue
    })
  );

  $mdThemingProvider.definePalette('printos-purple',
    $mdThemingProvider.extendPalette('purple', {
      '500': '#822980', // HP Purple
    })
  );

  $mdThemingProvider.theme('default')
    .primaryPalette('printos-blue')
    // Use HP Purple for the default accent color.
    // Accent palettes use A200, A100, A400 and A700 by default.
    .accentPalette('printos-blue', {
      'default': '500',
    })
    .warnPalette('deep-orange');

  // Disabling aria warnings until this is a higher program priority.
  // Also mutes spurious warnings generated from using with angular-translate.
  // See https://github.com/angular/material/issues/3441
  $mdAriaProvider.disableWarnings();
}



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/core/core.config.js